export enum ReviewListType {
  ACCOUNT = 'ACCOUNT',
  SECURITY = 'SECURITY',
}

export enum ReviewListStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
}

// TODO: align field names once the SP-backed API contract is finalized.
export interface ReviewListItem {
  id: string;
  type: ReviewListType;
  identifier: string; // account number or security symbol/CUSIP
  name: string;
  reason: string;
  status: ReviewListStatus;
  createdBy?: string;
  createdDate?: string;
  modifiedBy?: string;
  modifiedDate?: string;
}

// POST /api/Admin/RefAccountsSecurities - requires Bearer auth, Content-Type: application/json.
export interface RefAccountsSecuritiesRequest {
  Flag: string;
  uniqueIdentifier: string;
  referenceCode: string;
  referenceValue: string;
  referenceDesc?: string | null;
  productCode?: string | null;
  assetTypeCode?: string | null;
  assetSubTypeCode?: string | null;
  include: 'Y' | 'N';
  exclude: 'Y' | 'N';
  isActive: 'Y' | 'N';
  inactiveDate?: string | null; // ISO date-time
  application: string;
  alertCode?: string | null;
  createdBy?: string | null;
  lastUpdatedBy?: string | null;
}

export const REF_ACCOUNTS_SECURITIES_FLAG = {
  SEARCH: 'S',
  INSERT: 'I',
  UPDATE: 'U',
  DELETE: 'D',
} as const;
